<template>
  <div>
    <v-row class="no-gutters" align="center">
      <v-col class="col-12 col-sm-auto mr-sm-3">
        <div class="headline font-weight-bold card-text-color">
          {{ $t(`billAppointments.${listTitle}`) }}
        </div>
      </v-col>
      <v-col class="col-12 col-sm-auto mt-3 mt-sm-0 mr-sm-3">
        <v-btn
          color="primary"
          class="caption font-weight-bold"
          outlined
          block
          rounded
          small
          @click="selectAllBillAppointments"
          >{{ $t("billAppointments.selectItems.all") }}</v-btn
        >
      </v-col>
      <v-col class="col-12 col-sm-auto mt-3 mt-sm-0 mr-sm-3">
        <v-btn
          color="primary"
          class="caption font-weight-bold"
          outlined
          block
          rounded
          small
          @click="clearAllBillAppointments"
          >{{ $t("billAppointments.selectItems.clear") }}</v-btn
        >
      </v-col>
    </v-row>

    <slot name="filters"></slot>

    <div class="scrollable-section my-5">
      <transition-group name="slide-fade" mode="out-in">
        <bill-appointments-list-item
          v-for="billAppointment in billAppointmentsFullList"
          :key="billAppointment.appointmentId"
          :billAppointment="billAppointment"
          :selectedBillAppointments="selectedBillApps"
          @billappointmentupdated="updateBillAppointment"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import forEach from "lodash/forEach";
import BillAppointmentsListItem from "./BillAppointmentsListItem";

export default {
  props: {
    listTitle: {
      type: String,
      required: true
    },
    billAppointmentsFullList: {
      type: Array,
      required: true
    },
    selectedBillAppointments: {
      type: Array,
      required: true
    }
  },
  components: {
    BillAppointmentsListItem
  },
  data() {
    return {
      page: 1,
      resultsPerPageOptions: [1, 4, 10, "All"],
      resultsPerPage: 4,
      selectedBillApps: []
    };
  },
  created() {
    this.selectedBillApps = [...this.selectedBillAppointments];
  },
  methods: {
    updateBillAppointment(id, action) {
      let curBillAppointment = find(this.billAppointmentsFullList, {
        appointmentId: id
      });
      let selectedBillAppointmentIndex = findIndex(this.selectedBillApps, {
        appointmentId: id
      });

      if (action === "add") {
        if (selectedBillAppointmentIndex === -1)
          this.selectedBillApps.push(curBillAppointment);
        else
          this.selectedBillApps[selectedBillAppointmentIndex] =
            curBillAppointment;
      } else if (action === "remove") {
        if (selectedBillAppointmentIndex !== -1) {
          this.selectedBillApps.splice(selectedBillAppointmentIndex, 1);
        }
      }

      this.$emit("selectedbillappointmentsupdated", this.selectedBillApps);
    },
    isBillAppointmentSelected(id) {
      let billAppointmentIndex = findIndex(this.selectedBillApps, {
        appointmentId: id
      });
      return billAppointmentIndex !== -1;
    },
    selectAllBillAppointments() {
      forEach(this.billAppointmentsFullList, billAppointment => {
        let selectedBillAppointmentIndex = findIndex(this.selectedBillApps, {
          appointmentId: billAppointment.appointmentId
        });
        if (selectedBillAppointmentIndex === -1)
          this.selectedBillApps.push(billAppointment);
        else
          this.selectedBillApps[selectedBillAppointmentIndex] = billAppointment;
      });
      this.$emit("selectedbillappointmentsupdated", this.selectedBillApps);
    },
    clearAllBillAppointments() {
      forEach(this.billAppointmentsFullList, billAppointment => {
        let selectedBillAppointmentIndex = findIndex(this.selectedBillApps, {
          appointmentId: billAppointment.appointmentId
        });
        if (selectedBillAppointmentIndex !== -1)
          this.selectedBillApps.splice(selectedBillAppointmentIndex, 1);
      });
      this.$emit("selectedbillappointmentsupdated", this.selectedBillApps);
    },
    clearAllBillAppointmentsAllPages() {
      let billAppointmentsLength = this.selectedBillApps.length;
      this.selectedBillApps.splice(0, billAppointmentsLength);
      this.$emit("selectedbillappointmentsupdated", this.selectedBillApps);
    }
  },
  computed: {
    isAppointmentListEmpty() {
      return (
        this.billAppointmentsFullList &&
        this.billAppointmentsFullList.length === 0
      );
    }
  }
};
</script>

<style scoped>
.scrollable-section {
  max-height: calc(4 * 136px);
  overflow: auto;
}
@media only screen and (max-width: 599px) {
  .scrollable-section {
    max-height: unset;
    overflow: unset;
  }
}
</style>
